import React from 'react';
import loadable from '@loadable/component';
import config from '../../config';
import Preloader from '../../components/Preloader';

const ManagersPage = loadable(
  () => import(
    /* webpackChunkName: "managers-page-chunk" */
    './ManagersPage'
  ),
  {
    fallback: (
      <Preloader isDefault={config.isCustomApp} />
    ),
  }
);

export default ManagersPage;
